export default "__VITE_ASSET__BoPxTl7B__"